/* Зеркало «состояние движка S → входы сервиса» (engine-kit, план M3 §2 S3; circle K4, collage K4, mcard K4): одна точка записи входов
   из нескольких мест движка (syncFoot, смена файла, люди, лист настроек) без петли перерисовки и без записи под замком.
   - commit(next): next(prev) строит входы; равные по содержимому — запись не идёт и сервис отдаёт тот же объект (слушатели молчат);
     сервис заперт (заявка, создание, проверка владельца) — входы принадлежат заказу, запись не идёт;
   - свои записи отмечены: external() отвечает, менялись ли входы не зеркалом (повтор из «Истории», «Изменить» после перезагрузки,
     заявка нативной формы, загрузка файла) — только тогда экран переносит входы в S (viewOf → applyView); seen() — входы перенесены. */
import type { OrderService } from './order-service';

type Inputs = Record<string, string>;
export interface InputsMirror {
  /** S → входы; → записано ли */
  commit(next: (prev: Inputs) => Inputs): boolean;
  /** Входы сервиса (по умолчанию — сейчас) изменились не зеркалом с его последней записи или seen() */
  external(inputs?: Inputs): boolean;
  /** Входы перенесены в S: дальше они «свои» */
  seen(inputs?: Inputs): void;
  /** Этот объект входов записало зеркало */
  own(inputs: Inputs): boolean;
}

/** Одинаковые ли входы: те же ключи с теми же строками */
export function sameInputs(a: Inputs, b: Inputs): boolean {
  if (a === b) return true;
  const keys = Object.keys(a);
  return keys.length === Object.keys(b).length && keys.every(key => Object.hasOwn(b, key) && a[key] === b[key]);
}

export function createInputsMirror(svc: OrderService): InputsMirror {
  const written = new WeakSet<Inputs>();
  /** Последние входы, которые зеркало знает (своя запись или seen) */
  let known: Inputs | null = null;
  return {
    commit(next) {
      if (svc.derive().locked) return false;
      let wrote: Inputs | null = null;
      svc.setters.inputs(current => {
        const value = next(current);
        if (sameInputs(value, current)) return current;
        wrote = value;
        written.add(value);
        known = value;
        return value;
      });
      return wrote !== null;
    },
    external(inputs = svc.get().inputs) {
      if (inputs === known || written.has(inputs)) return false;
      if (known && sameInputs(inputs, known)) {
        known = inputs;
        return false;
      }
      return true;
    },
    seen(inputs = svc.get().inputs) {
      known = inputs;
    },
    own: inputs => written.has(inputs),
  };
}
